module.exports = __webpack_public_path__ + "static/media/husk_white_logo.9393e93d.png";